import * as ng from 'angular';

export class OrganEditPanelFloatingIpsController {
    public static $inject: string[] = [];

    public $editFormOrganism;
    public cancel;
    public panelRight;
}

export class OrganEditPanelFloatingIpsComponent implements ng.IComponentOptions {
    public bindings = {
        cancel: '<',
        panelRight: '<'
    };
    public require = {
        $editFormOrganism: '^organismEditFormNetwork'
    };
    public controllerAs = '$editPanelOrgan';
    public template = require('./network-floating.html');
    public controller = OrganEditPanelFloatingIpsController;
}
